import React, { Component } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode";
import { Typography } from "@mui/material";

class QRCodeRenderer extends Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = {
      error: null,
    };
  }

  renderQRCode(content) {
    const node = this.canvasRef.current;

    QRCode.toCanvas(node, content, { scale: 16, margin: 2 }, (error) => {
      if (error) {
        this.setState({ error });
      } else {
        this.setState({ error: null });
      }
    });
  }

  componentDidMount() {
    if (this.props.content) {
      this.renderQRCode(this.props.content);
    }
  }

  componentDidUpdate(prevProps) {
    const prevContent = prevProps.content;
    const newContent = this.props.content;

    if (newContent && prevContent !== newContent) {
      this.renderQRCode(newContent);
    }
  }

  render() {
    if (this.state.error) {
      return <Typography>{this.state.error.message}</Typography>;
    }

    return <canvas ref={this.canvasRef} />;
  }
}

QRCodeRenderer.propTypes = {
  content: PropTypes.string.isRequired,
};

export default QRCodeRenderer;
